module.exports = __webpack_public_path__ + "static/media/fo.037e466d.svg";